import { Plus, Minus } from 'lucide-react';

export default function AdditionCounter({
  label,
  qty,
  maxQty,
  onInc,
  onDec,
}: {
  label: string;
  qty: number;
  maxQty: number;
  onInc: () => void;
  onDec: () => void;
}) {
  return (
    <div className="flex items-center justify-between py-2">
      <span className="text-sm">{label}</span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onDec}
          aria-label="decrement"
          className="p-1 rounded border disabled:opacity-50"
          disabled={qty <= 0}
        >
          <Minus size={16} />
        </button>
        <span className="w-6 text-center text-sm tabular-nums">{qty}</span>
        <button
          type="button"
          onClick={onInc}
          aria-label="increment"
          className="p-1 rounded border disabled:opacity-50"
          disabled={qty >= maxQty}
        >
          <Plus size={16} />
        </button>
        <span className="text-xs text-gray-500">/ {maxQty}</span>
      </div>
    </div>
  );
}
